import React from 'react';
import { Overview } from 'src/features/MM/components/templates/Overview';
import { PageModelLayout } from '../../components/molecules/PageModelLayout';
import { FilterBar } from '../../components/organisms/FilterBar';
import { MMKeyMetrics } from '../../features/MM/components/organisms/MMKeyMetrics';
import { GenAIActionButtons } from 'src/components/molecules/GenAIActionButtons';

export const OverviewPage: React.FC = () => {
  return (
    <PageModelLayout
      filterBar={<FilterBar includeAggregation />}
      pageTitle="Overview"
      keyMetrics={<MMKeyMetrics />}
      extraButtons={<GenAIActionButtons />}>
      <Overview />
    </PageModelLayout>
  );
};
